import React, { useState, useRef, useEffect } from 'react'
import {
    Button, Typography, Alert, QRCode, Flex, Table, Badge, Tabs, Drawer, Form,
    Checkbox, Input, Upload, Select, Card, Divider, InputNumber, Tag, Tooltip, Skeleton,
    Breadcrumb,
    Image,
    DatePicker, ConfigProvider
} from 'antd'
import api, { BASEURL } from '../../../service/axios'
import { useToasts } from 'react-toast-notifications';
import ReactToPrint from 'react-to-print';
import TelefoneBrasileiroInput from "react-telefone-brasileiro";
import {
    CloseOutlined,
    UploadOutlined,
    FileTextOutlined,
    DownloadOutlined,
    FilePdfFilled
} from '@ant-design/icons';
import { userState } from '../../../service/database'
import { useRecoilState } from 'recoil'
import dayjs from 'dayjs';
import InputMask from 'react-input-mask';
import { cnpj, cpf, validator } from 'cpf-cnpj-validator'
import { useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import BAIXACRT from '../../../images/baixa.png'
import GOVBR from '../../../images/gov.png'
import locale from 'antd/locale/pt_BR';


export const CRTAprovadas = (props) => {

    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const [msg, setMsg] = useState('')
    const { addToast } = useToasts()
    const [dataMinhasCRT, setDataMinhasCRT] = useState(undefined)
    const [dataSolicitacoes, setDataSolicitacoes] = useState(undefined)
    const [user, setUser] = useRecoilState(userState)
    const [open, setOpen] = useState(false)
    const [CNPJ, setCNPJ] = useState('10.260.249/0003-51')
    const [selected, setSelected] = useState(undefined)
    const [openSelected, setOpenSelected] = useState(false)
    const [solicitacao, setSolicitacao] = useState({
        formapagamento: 0,
        crq: user?.crq,
        vinculo: 0,
        nome: user?.nome,
        cpf: user?.cpf,
        horas: 2,
        atividade: "Responsável Técnico da Empresa.",
        anexo: false,
        firma: {

        }
    })

    const [fileList, setFileList] = useState([]);
    const [dataBaixa, setDataBaixa] = useState(dayjs())


    useEffect(() => {
        if (user?.isprofissional === 1)
            getMinhasCRTs()
        else
            navigate('/login')
    }, [])


    async function getMinhasCRTs() {
        try {
            setLoading(true)
            const result = await api.get('/api/v1.0/registrado/minhas-crt',
                {
                    headers: {
                        'x-access-token': user?.token2
                    }
                }
            )
            console.log(result.data)
            setDataMinhasCRT(result.data)
        } catch (error) {
            addToast(error.message, { autoDismiss: true, appearance: 'error' })
        }
        setLoading(false)
    }



    function renderComunicacoes() {
        return <Flex vertical gap={5}>
            <Flex justify='flex-end'>

            </Flex>
            <Table id='tablesmall2' size='small' bordered pagination={false} dataSource={dataMinhasCRT} loading={loading}
                defaultExpandAllRows={true}
                expandable={{
                    expandedRowRender: record => <Flex flex={1} style={{ margin: 0 }} align='center' key={"data".concat(record.id)}>
                        <Table size='small' showHeader={false} style={{ width: '100%' }} bordered pagination={false} dataSource={record.data} styles={{
                            content: {
                                fontSize: '0.9em'
                            }
                        }}>
                            <Table.Column render={(subtext, subitem, subindex) => {
                                return <Flex style={{ fontSize: '0.95em' }}>
                                    <Tag color={'error'}>Baixa de Responsabidade Técnica</Tag></Flex>
                            }} />
                            <Table.Column render={(subtext, subitem, subindex) => {
                                if (subitem.situacao === 'solicitada')
                                    return <Tag color={'blue'}>{subitem.situacao}</Tag>
                                else if (subitem.situacao === 'negada')
                                    return <Tag color={'red'}>{subitem.situacao}</Tag>
                                else if (subitem.situacao === 'efetuada')
                                    return <Tag color={'green'}>{subitem.situacao}</Tag>
                                return subitem.situacao
                            }} />
                            <Table.Column render={(subtext, subitem, subindex) => {
                                return <Flex style={{ fontSize: '0.95em' }}>{dayjs(subitem.criadoem).format('DD/MM/YYYY HH:mm')}</Flex>
                            }} />

                            <Table.Column render={(subtext, subitem, subindex) => {
                                return <Button icon={<FilePdfFilled />} size='small' type='link'
                                    onClick={async () => {
                                        try {
                                            const result = await api.get('/api/v1.0/registrado/crt/files/download/baixa',
                                                {
                                                    headers: {
                                                        'x-access-token': user?.token2
                                                    },
                                                    params: {
                                                        arquivo: subitem.arquivo
                                                    },
                                                    responseType: 'blob'
                                                }
                                            )

                                            const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                            // Cria uma URL temporária para o Blob 
                                            const url = window.URL.createObjectURL(pdfBlob);
                                            // Cria         um elemento <a> temporário para iniciar o download 
                                            const tempLink = document.createElement("a");
                                            tempLink.href = url;
                                            tempLink.setAttribute("download", "".concat('formulario de baixa', '.pdf'));
                                            // Define o nome de arquivo desejado para o arquivo baixado 
                                            // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                            document.body.appendChild(tempLink);
                                            tempLink.click();
                                            // Limpa os elementos temporários e a URL 
                                            document.body.removeChild(tempLink);
                                            window.URL.revokeObjectURL(url);

                                        } catch (error) {
                                            addToast(error.message, { appearance: 'error', autoDismiss: true })
                                        }
                                    }}></Button>
                            }} />
                        </Table>
                    </Flex>,
                    rowExpandable: record => record.data?.length > 0,
                }}>
                <Table.Column hidden={isMobile} title={"Processo"} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }}>{item.processo}</Flex>
                }}

                />

                <Table.Column title={"Razão Social"} render={(txt, item, index) => {
                    return <Flex gap={5} align='center'>
                        <Flex style={{ fontSize: '0.9em' }}>{item.razao}</Flex>
                        {item.data.length > 0 && <Flex><Tag color={'red'}>Baixa solicitada</Tag> </Flex>}
                    </Flex>
                }} />
                <Table.Column hidden={isMobile} title={"CNPJ"} align='center' width={130} render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>{item.cnpj}</Flex>
                }} />

                <Table.Column title={"Vigência"} align='center' render={(txt, item, index) => {
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>{item.vigencia}</Flex>
                }} />
                <Table.Column title={"Validade"} width={115} align='center' render={(txt, item, index) => {
                    if (!item.vigencia)
                        return <Flex></Flex>
                    let validade = "31/03/".concat(item.vigencia + 1)
                    return <Flex style={{ fontSize: '0.9em' }} justify='center'>
                        {validade}
                    </Flex>
                }} />

                <Table.Column title={""} render={(txt, item, index) => {

                    if (!item.vigencia)
                        return <Flex justify='flex-end'>
                            {
                                <Button type='link' style={{ fontSize: '0.95em' }} icon={<Image preview={false} height={14} width={14} src={BAIXACRT} />}
                                    onClick={() => {

                                        let no = true
                                        item.data.map(it => {
                                            if (it.situacao === 'solicitada') {
                                                addToast("Já existe um pedido de baixa para essa CRT!", { autoDismiss: true, appearance: 'info' })
                                                no = false
                                            }
                                        })

                                        if (no) {
                                            setSelected(item)
                                            setOpen(true)
                                        }
                                    }}>Baixa</Button>
                            }
                        </Flex>

                    return <Flex justify='flex-end' align='center'>
                         <Tooltip title={"Download da Comunicação de Responsabilidade Téccnica"}>
                        <Button type='link' size='small' icon={<DownloadOutlined />} style={{ fontSize: '0.95em' }}
                            onClick={async () => {
                                try {
                                    const result = await api.get('/api/v1.0/registrado/ccrt/download',
                                        {
                                            headers: {
                                                'x-access-token': user?.token2
                                            },
                                            params: {
                                                id: item.crtvigenciaid
                                            },
                                            responseType: 'blob'
                                        }
                                    )
                                    //   console.log(result.data)


                                    const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                    // Cria uma URL temporária para o Blob 
                                    const url = window.URL.createObjectURL(pdfBlob);
                                    // Cria         um elemento <a> temporário para iniciar o download 
                                    const tempLink = document.createElement("a");
                                    tempLink.href = url;
                                    tempLink.setAttribute("download", "ccrt".concat('.pdf'));
                                    // Define o nome de arquivo desejado para o arquivo baixado 
                                    // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                    document.body.appendChild(tempLink);
                                    tempLink.click();
                                    // Limpa os elementos temporários e a URL 
                                    document.body.removeChild(tempLink);
                                    window.URL.revokeObjectURL(url);


                                } catch (error) {
                                    addToast(error, {
                                        autoDismiss: true,
                                        appearance: 'error'
                                    })
                                }
                            }}>Download</Button>
                            </Tooltip>

                        <Divider vertical />
                        {
                            <Tooltip title={"Comunicar a Baixa da sua Comunicação de Responsabilidade Técnica referente a empresa ".concat(item.razao)}>
                                <Button type='link' style={{ fontSize: '0.95em' }} icon={<Image preview={false} height={14} width={14} src={BAIXACRT} />}
                                    onClick={() => {
                                        let no = true
                                        item.data.map(it => {
                                            if (it.situacao === 'solicitada') {
                                                addToast("Já existe um pedido de baixa para essa CRT!", { autoDismiss: true, appearance: 'info' })
                                                no = false
                                            }
                                        })

                                        if (no) {
                                            setSelected(item)
                                            setOpen(true)
                                        }
                                    }}>Baixa</Button>
                            </Tooltip>
                        }

                    </Flex>
                }} />


                <Table.Column title={""} align='center' render={(txt, item, index) => {
                    if (!item.vigencia)
                        return <Flex></Flex>
                    let validade = "31/03/".concat(item.vigencia + 1)
                    return <Flex justify='center'>
                        <Tooltip title={"Download do certificado da Empresa ".concat(item.razao)}>
                            <Button
                                type='link' size='small'
                                icon={<DownloadOutlined />}
                                style={{ fontSize: '0.95em' }}
                                onClick={async() => {
                                    try {
                                        const result = await api.get('/api/v1.0/registrado/certificado/pj',
                                            {
                                                headers: {
                                                    'x-access-token': user?.token2
                                                },
                                                params: {
                                                    id: item.firmaid
                                                },
                                                responseType: 'blob'
                                            }
                                        )

                                        const nomes = item.razao.split(' ')
                                        const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                        // Cria uma URL temporária para o Blob 
                                        const url = window.URL.createObjectURL(pdfBlob);
                                        // Cria         um elemento <a> temporário para iniciar o download 
                                        const tempLink = document.createElement("a");
                                        tempLink.href = url;
                                        tempLink.setAttribute("download", "Certificado ".concat(nomes[0], '.pdf'));
                                        // Define o nome de arquivo desejado para o arquivo baixado 
                                        // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                        document.body.appendChild(tempLink);
                                        tempLink.click();
                                        // Limpa os elementos temporários e a URL 
                                        document.body.removeChild(tempLink);
                                        window.URL.revokeObjectURL(url);
                                    } catch (error) {
                                        addToast(error.message, { autoDismiss: true, appearance: 'error' })
                                    }
                                }}
                            >Cert.PJ</Button>
                        </Tooltip>

                    </Flex>
                }} />


            </Table>
        </Flex>
    }






    return <Flex vertical gap={10}>

        <Breadcrumb items={[
            {
                title: <Flex align='center' gap={5}><FileTextOutlined /> Comunicações de Responsabilidade Técnica</Flex>,
            }, {
                title: "Ativas (".concat(dataMinhasCRT ? dataMinhasCRT?.length : '', ')')
            }
        ]} />

        {renderComunicacoes()}

        <Drawer
            closable={false}
            size={isMobile ? '100%' : '80%'}
            open={open}
            onClose={() => {
                getMinhasCRTs()
                setOpen(false)
            }}

            destroyOnHidden={true}
            title={<Flex align='center' gap={5} justify='space-between'>
                <Flex align='center' gap={10}>
                    <Image preview={false} height={20} width={20} src={BAIXACRT} />
                    <Flex>SOLICITAÇÃO DE BAIXA DE COMUNICAÇÃO DE RESPONSABILIDADE TÉCNICA</Flex>
                </Flex>

                <Button size='large' type='link' icon={<CloseOutlined style={{ color: 'royalblue' }} />} onClick={() => {
                    setOpen(false)
                    getMinhasCRTs()
                }}></Button>
            </Flex>}
            footer={<Flex justify='flex-end' align='center'>
                <Button type='primary' loading={loading} disabled={fileList.length === 0}
                    style={{ width: 90 }}
                    onClick={async () => {
                        const formData = new FormData();
                        formData.append("databaixa", JSON.stringify(selected))
                        formData.append('file', fileList[0]);

                        try {
                            const response = await api.post('api/v1.0/upload/crt/baixa', formData, {
                                headers: {
                                    'Content-Type': 'multipart/form-data',
                                    'x-access-token': user?.token2
                                }
                            });
                            console.log('Success:', response.data);
                            addToast("Solicitação efetuada!", { appearance: 'success', autoDismiss: true })
                            getMinhasCRTs()
                            setFileList([])
                            setOpen(false)
                        } catch (error) {
                            console.error('Error uploading file:', error);
                            addToast(error.message, { appearance: 'error', autoDismiss: true })
                        }
                    }}> Enviar </Button>
            </Flex>}>

            <Card>
                <Flex vertical>
                    <span>Informe a data em que você deixou a responsibilidade técnica da Empresa <b>{selected?.razao}</b>.</span>
                    <Flex>
                        <ConfigProvider locale={locale}>
                            <DatePicker format={'DD/MM/YYYY'} allowClear={false}
                                value={dataBaixa}
                                onChange={(e) => {
                                    setDataBaixa(e)
                                }}
                            />
                        </ConfigProvider>
                    </Flex>
                </Flex>
            </Card>

            <Card style={{ marginTop: 15 }}>
                <span>Efetue o download do formulário de Baixa da Comunicação de Respondabilidade Técnica da Empresa em seguida, assine digital do documento.</span>
                <div style={{ marginTop: 10 }}>
                    Caso não possuam certificado digital, orienta-se que a assinatura seja realizada por meio da plataforma <a href='https://assinador.iti.br/assinatura/index.xhtml' target='_blank'>
                        gov.br</a>, que disponibiliza a
                    funcionalidade de assinatura eletrônica válida e reconhecida legalmente.
                </div>

                <Flex align='center' style={{ marginTop: 10 }} gap={20}>
                    <Button
                        icon={<DownloadOutlined />}
                        onClick={async () => {
                            try {
                                console.log(selected)
                                const result = await api.get('/api/v1.0/registrado/baixa-crt/formulario',
                                    {
                                        headers: {
                                            'x-access-token': user?.token2
                                        },
                                        params: {
                                            id: selected.id,
                                            databaixa: dataBaixa
                                        },
                                        responseType: 'blob'
                                    }
                                )
                                const pdfBlob = new Blob([result.data], { type: "application/pdf" });
                                // Cria uma URL temporária para o Blob 
                                const url = window.URL.createObjectURL(pdfBlob);
                                // Cria         um elemento <a> temporário para iniciar o download 
                                const tempLink = document.createElement("a");
                                tempLink.href = url;
                                tempLink.setAttribute("download", "baixa-crt-".concat(selected.id, '.pdf'));
                                // Define o nome de arquivo desejado para o arquivo baixado 
                                // Adiciona o elemento <a> ao corpo e clica nele para iniciar o download 
                                document.body.appendChild(tempLink);
                                tempLink.click();
                                // Limpa os elementos temporários e a URL 
                                document.body.removeChild(tempLink);
                                window.URL.revokeObjectURL(url);


                            } catch (error) {
                                addToast(error, {
                                    autoDismiss: true,
                                    appearance: 'error'
                                })
                            }

                        }}>Download Formulário
                    </Button>

                    <a href='https://assinador.iti.br/assinatura/index.xhtml' style={{ marginTop: 10 }} target='_blank'>
                        <Image preview={false} src={GOVBR} width={105} style={{ objectFit: 'contain' }} />
                    </a>
                </Flex>


            </Card>



            <Card style={{ marginTop: 15 }}>
                <Flex vertical flex={1}>
                    <Flex gap={5} align='center' style={{ fontWeight: 'bold' }}>{'Anexe o formulário baixado e assinado digitalmente'}</Flex>
                    <Flex style={{ fontSize: '0.8em', color: 'gray', fontStyle: 'italic' }}>O formulário deve estar assinado.</Flex>

                    <Flex justify='flex-start'>
                        <Upload {...props}
                            fileList={fileList}
                            defaultFileList={solicitacao.url_formulario && [
                                {
                                    uid: '1',
                                    name: 'formulario.pdf',
                                    status: 'done',
                                    url: 'http://www.baidu.com/xxx.png',
                                    percent: 100,
                                }
                            ]}

                            onRemove={async (file) => {
                                setLoading(true)
                                try {

                                    const index = fileList.indexOf(file);
                                    const newFileList = fileList.slice();
                                    newFileList.splice(index, 1);
                                    setFileList(newFileList);

                                } catch (error) {
                                    addToast(error.message, { appearance: 'error', autoDismiss: true })
                                }
                                setLoading(false)
                            }}
                            name="file"
                            maxCount={1}
                            showUploadList={true}
                            beforeUpload={async (file) => {
                                const isJpgOrPng = file.type === 'application/pdf';
                                const isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
                                try {
                                    if (!isJpgOrPng) {
                                        addToast('Você só pode fazer upload de documentos no formato PDF!', { appearance: 'error', autoDismiss: true });
                                    }

                                    if (!isLt2M) {
                                        //   console.log('A imagem deve ser menor que 3MB!')
                                        addToast('O documento não poder ser maior que 5mb!', { appearance: 'error', autoDismiss: true });
                                        // message.error('A imagem deve ser menor que 3MB!');
                                    }
                                } catch (error) {
                                    isLt2M = false
                                }

                                setFileList([...fileList, file]);
                                // console.log('beforeUpload', isJpgOrPng, isLt2M)
                                return false//isJpgOrPng && isLt2M;
                            }}

                            onChange={(info) => {
                                // console.log('onChange', info.file.status)
                                setSolicitacao({ ...solicitacao, anexo: false })
                                if (info.file.status === 'uploading') {
                                    setLoading(true)
                                    return;
                                }
                                if (info.file.status === 'done') {
                                    // console.log("INFO:",info.file.response.filename)
                                    // setSolicitacao({ ...solicitacao, anexo: true })
                                    setLoading(false)
                                    setSolicitacao({ ...solicitacao, url_formulario: "formulario.pdf" })
                                    //  setProduto({ ...produto, url: BASEURLRAIZ.concat('products/', info.file.response.filename) })
                                }

                                if (info.file.status === 'error') {
                                    // Get this url from response in real world.
                                    addToast(info?.file.response?.error, { autoDismiss: true, appearance: 'error' })
                                    console.log('INFO', info)
                                    info.fileList.pop()
                                    setLoading(false)
                                    return;
                                }
                                if (info.file.status === undefined) {
                                    setLoading(false)
                                    info.fileList.pop()
                                    console.log("tamanho", info.fileList.length)
                                    return;
                                }


                            }}


                        >
                            <Button icon={<UploadOutlined />}>Anexar Fomulario</Button>
                        </Upload>
                    </Flex>
                </Flex>
            </Card>




        </Drawer>

    </Flex>

}